import { createContext } from 'react';

const BookLocationDocumentValuesContext = createContext({
  currentBookLocationDocument: null,
  nextDocumentLocation: null,
  nextDocumentLocationWithText: null,
  previousDocumentLocation: null,
  isEndOfDocument: false,
});

export default BookLocationDocumentValuesContext;
